<ng-template>
  @if (hasItems$ | async) {
    <div class="modus-menu">
      <ng-content select="md-menu-item"></ng-content>
    </div>
  }
</ng-template>
